<template>
  <div>
    <div>
      <div
        :class="bottomBorder ? 'border-b-2 border-matte-gray' : '' "
        class="py-10"
      >
        <div class="px-4 pb-2 lg:px-0 lg:flex lg:items-end flex-wrap">
          <div
            class="flex items-center lg:items-end cursor-pointer"
          >
            <div
              v-if="$slots.icon"
              class="h-10 w-10 mr-2 lg:mr-4 lg:ml-6"
            >
              <slot name="icon" />
            </div>
            <h4
              v-if="$slots.title"
              class="text-lg md:text-2xl text-black font-bold lg:mr-8 lg:mb-0"
            >
              <slot name="title" />
            </h4>
          </div>
          <div class="flex items-end">
            <h4
              v-if="$slots.metric"
              class="text-lg md:text-2xl text-cta-primary font-bold mr-2 mb-0"
            >
              <slot name="metric" />
            </h4>
            <p
              v-if="$slots.metricText"
              class="lg:text-xl"
            >
              <slot name="metricText" />
            </p>
          </div>
          <div
            v-if="cards.length > 0 && !recommendedCourseCards && !$route.name.includes('instructor')"
            class="hidden md:block flex items-end ml-auto"
          >
            <nuxt-link
              v-if="cards.length >= 4"
              class="text-cta-primary"
              :to="productType === 'TRENDING' ? `/courses/` : `/courses/format/${seeMoreLink}`"
            >
              {{ 'See All >' }}
            </nuxt-link>
          </div>
        </div>
        <div class="relative overflow-hidden">
          <div v-if="typeof cards === undefined || cards.length === 0">
            <div class="grid grid-cols-2 grid-rows-1 gap-6 md:grid-cols-5">
              <l-shadow-card
                v-for="i in 5"
                :key="i"
              />
            </div>
          </div>
          <div
            v-else
            ref="carousel"
            class="flex space-x-2 md:space-x-4 py-2 items-center"
            :class="{ 'pl-0': atStart, 'pr-0': atEnd }"
          >
            <div
              v-if="cards.length >= 4"
              class="w-12 h-12"
            >
              <button
                v-if="!atStart"
                class="hidden md:block w-12 h-12 justify-center items-center text-3xl text-cta-primary transition duration-300"
                @click="scroll(-1)"
              >
                <img
                  src="https://summitproedu.imgix.net/redesign-assets/icons/2025/scroll_arrow.svg"
                  alt="Chevron Icon"
                  class="h-12 mx-auto transform -scale-x-100"
                />
              </button>
            </div>
            <div
              ref="cardsContainer"
              :class="cards.length >= 4 ? '': 'pl-4'"
              class="flex space-x-2 md:space-x-4 overflow-x-auto flex-nowrap overflow-x-scroll"
            >
              <t-scroll-card
                v-for="(card, index) in cards"
                :key="index"
                :card="card"
                :product-type="productType"
                :variant="variant"
                :show-location="showLocation"
              />
              <div v-if="!recommendedCourseCards">
                <div
                  v-if="cards.length >= 4 && !$route.name.includes('instructor')"
                  class="flex-shrink-0 w-36 p-4 bg-transparent items-center flex justify-center items-center"
                >
                  <nuxt-link
                    :to="productType === 'TRENDING' ? `/courses/` : `/courses/format/${seeMoreLink}`"
                    class="font-bold text-cta-primary"
                  >
                    See All >
                  </nuxt-link>
                </div>
                <div
                  v-else
                  class="flex-shrink-0 w-56 p-4 bg-transparent items-center flex justify-center"
                >
                  <nuxt-link
                    to="/courses"
                    class="font-bold text-cta-primary"
                  >
                    Browse Other Courses <t-icon name="chevron-right" />
                  </nuxt-link>
                </div>
              </div>
            </div>
            <div
              v-if="cards.length >= 4"
              class="w-12 h-12"
            >
              <button
                v-if="!atEnd"
                class="hidden md:block w-12 h-12 justify-center items-center text-3xl text-cta-primary transition duration-300"
                @click="scroll(1)"
              >
                <img
                  src="https://summitproedu.imgix.net/redesign-assets/icons/2025/scroll_arrow.svg"
                  alt="Chevron Icon"
                  class="h-12 mx-auto"
                /> <br />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productType: {
      type: String,
      default: 'VIDEO',
    },
    cards: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: 'default',
    },
    recommendedCourseCards: {
      type: Boolean,
      default: false,
    },
    showLocation: {
      type: Boolean,
      default: false,
    },
    bottomBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scrollPosition: 0,
    };
  },
  computed: {
    atStart() {
      return this.scrollPosition === 0;
    },
    atEnd() {
      const cardsContainer = this.$refs.cardsContainer;
      const carousel = this.$refs.carousel;
      return (
        cardsContainer
        && carousel
        && cardsContainer.offsetWidth + this.scrollPosition >= carousel.scrollWidth
      );
    },
    seeMoreLink() {
      switch (this.productType) {
        case 'TEXT':
          return 'text';
        case 'LIVE':
          return 'live';
        case 'VIDEO':
          return 'video';
        case 'LIVESTREAM':
          return 'live-streaming';
        case 'WEBINAR':
          return 'webinar';
        case 'PODCAST':
          return 'podcast';
        default:
          return 'video'; // Optional: Handle unknown product types
      }
    },
  },
  mounted() {
    console.log('horizontal scroll bar layout mounted', this.cards);
  },
  methods: {
    scroll(direction) {
      const cardsContainer = this.$refs.cardsContainer;
      if (cardsContainer) {
        const scrollAmount = direction * 800; // Adjust the scroll amount as needed
        this.scrollPosition += scrollAmount;
        cardsContainer.scrollTo({
          left: this.scrollPosition,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>

<style scoped>
/* Add custom styles if needed */
.overflow-x-scroll::-webkit-scrollbar {
  display: none;
}
</style>
